import React, { useState } from "react";
import { Paper, Popover, Typography } from "@mui/material";

import "./premiumOverview.css";
import roles from "../../../../constants/roles";
import { formatTwoDecimalPlaces } from "../../../../utils/commonFunctions/decimal";

const PremiumOverviewContainer: React.FC<any> = ({
	open,
	anchorEl,
	handleClose,
	premiumDetails,
	enrollment
}): JSX.Element => {
	// console.log("Checking the rresponse-------->", enrollment);
	const [relationShipType, setRelationshipType] = useState("");
	// console.log("EnrollmetnsDataConsoleCheck------>>", enrollment);
	return (
		<div className="plan-overall-main-container">
			<Popover
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "center",
					horizontal: "left"
				}}
				transformOrigin={{
					vertical: "center",
					horizontal: "right"
				}}
				PaperProps={{
					style: {
						width: "300px", // Adjust width as needed
						padding: "1rem" // Adjust padding as needed
					}
				}}
			>
				<Paper style={{ boxShadow: "none" }}>
					<Typography variant="h6" fontWeight={700}>
						Premiums Overview
					</Typography>
					<Typography variant="body1" marginY={1} fontSize={15} textAlign="justify">
						This section outlines the individual premium amount and their types.
					</Typography>
					<div className="grid-2x-header">
						<span>Types</span>
						<span>Premium Amt.</span>
					</div>
					{enrollment.map((item: any, index: number) => {
						const { member, premium_amount } = item;
						// console.log("EnrollmetnsDataConsoleCheck------>>", premium_amount);
						return (
							<div key={index} className="plan-grid-2x" style={{ marginTop: 6 }}>
								<span className="label">
									{member.relationship === null && member.role === "EMPLOYEE"
										? "STANDARD"
										: member.relationship}
								</span>
								<span>$ {formatTwoDecimalPlaces(premium_amount) || "N/A"}</span>
							</div>
						);
					})}
				</Paper>
			</Popover>
		</div>
	);
};

export default PremiumOverviewContainer;
